import React from "react";
import PageLayout from "../../../../shared/PageLayout";
import PreviewLayout from "./PreviewLayout";

const PreviewTip2: React.FC = () => {
    return (
        <PageLayout>
            <PreviewLayout />
        </PageLayout>
    );
};

export default PreviewTip2;
